import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { MEDIA_QUERY, FONT } from '../../styles/emotion';
import COLORS, { COLORS_SEMANTIC } from '../../styles/emotion/colors3';
import { SectionMessageType } from './SectionMessage';
// @ts-expect-error: Allow JS
import { Link } from '../Link';
import { AlertIcon } from '../SvgIcons/Alert';
import { CheckmarkCircleIcon } from '../SvgIcons/CheckmarkCircle';
import { InfoIcon } from '../SvgIcons/Info';
import { RemoveIcon } from '../SvgIcons/Remove';

export const Container = styled.div<{ type?: SectionMessageType }>`
  padding: 20px;
  border-radius: 8px;
  ${MEDIA_QUERY.MOBILE} {
    margin: 0 20px;
  }
  ${({ type }) => {
    if (type) {
      if (type === 'Confirmation') {
        return `background-color: ${COLORS_SEMANTIC.POSITIVE_005}`;
      }
      if (type === 'Warning') {
        return `background-color: ${COLORS_SEMANTIC.WARNING_005};`;
      }
      if (type === 'Error') {
        return `background-color: ${COLORS_SEMANTIC.NEGATIVE_005}`;
      }
    }
    /** Default background color is same as Info type */
    return `background-color: ${COLORS_SEMANTIC.INFORMATIONAL_005};`;
  }}
`;

export const ContentContainer = styled.div<{ addTopSpacing?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: left;
  ${({ addTopSpacing }) => addTopSpacing && 'margin-top: 8px;'}
`;

export const TextContainer = styled.div`
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: center;
`;

export const Title = styled.h2`
  font-size: ${FONT.FONT_SIZE_SMALL};
  font-weight: ${FONT.FONT_WEIGHT_REGULAR};
  color: ${COLORS.BLACK_100};
  letter-spacing: 0;
  line-height: 24px;
  margin-top: 0;
  margin-bottom: 4px;
`;

export const Description = styled.p`
  font-size: ${FONT.FONT_SIZE_SMALL};
  font-weight: ${FONT.FONT_WEIGHT_REGULAR};
  color: ${COLORS.BLACK_050};
  letter-spacing: 0;
  line-height: 22px;
  margin: 0;
`;

export const StyledLink = styled(Link)`
  margin-top: 12px;
`;

export const basicIconStyles = css`
  margin-right: 8px;
  width: 24px !important;
  height: 24px !important;
`;

export const StyledAlertIcon = styled(AlertIcon)`
  ${basicIconStyles}
  color: ${COLORS_SEMANTIC.WARNING_100};
`;

export const StyledCheckmarkIcon = styled(CheckmarkCircleIcon)`
  ${basicIconStyles}
  color: ${COLORS_SEMANTIC.POSITIVE_100};
`;

export const StyledRemoveIcon = styled(RemoveIcon)`
  ${basicIconStyles}
  color: ${COLORS_SEMANTIC.NEGATIVE_100};
`;

export const StyledInfoFilledIcon = styled(InfoIcon)`
  ${basicIconStyles}
  color: ${COLORS_SEMANTIC.INFORMATIONAL_100};
`;
